import { useTheme } from 'styled-components';
import { getTextAlign } from '@applyft-web/ui-components';
import { darkPalette, isDarkTheme } from '../theme';

export const useStripeFieldsStyle = () => {
  const theme = useTheme();

  return {
    base: {
      color: theme.colors.text,
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 400,
      fontFamily: 'Open Sans, sans-serif',
      textAlign: getTextAlign(theme.isRtl),
      '::placeholder': {
        color: isDarkTheme(theme) ? darkPalette.textTertiary : '#909090',
        letterSpacing: '1.2px',
        fontSize: '16px',
        lineHeight: '22px',
      },
    },
  };
};
